var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useState } from 'react';
import { useWalkInListState } from './hooks/useWalkInListState';
import WalkInListHeader from './components/WalkInListHeader';
import { WalkInListContent } from './components/WalkInListContent';
import WalkInListDatePicker from './components/WalkInListDatePicker';
import Tabs from '../../../common/Tabs';
import { AddWalkInClientContainer } from '../../../../modules/shared/appointments/walk-in-list/add-walk-in-client/add-walk-in-client-container';
import { CustomAcceptWalkInClient } from '../../../../modules/shared/appointments/walk-in-list/accept-walk-in-client';
import { useSession, getSessionShop } from '../../../../modules/infra/session';
import { WaitlistSettings } from './components/WaitlistSettings';
import { useUpdateWalkInListSettings } from '../../../../modules/shared/appointments/walk-in-list/hooks/use-update-walk-in-list-settings';
import { useWaitingListSettings } from '../../../../modules/shared/appointments/walk-in-list/hooks/use-waiting-list-settings';
import { t } from '../../../../modules/infra/i18n';
var TAB_INDEX_TODAY = 0;
var TAB_INDEX_FULL_LIST = 1;
export var WalkInList = function (_a) {
    var onClose = _a.onClose;
    var _b = useState(false), showAddWalkIn = _b[0], setShowAddWalkIn = _b[1];
    var _c = useState(null), selectedClient = _c[0], setSelectedClient = _c[1];
    var _d = useState(TAB_INDEX_TODAY), tabIndex = _d[0], setTabIndex = _d[1];
    var _e = useState(false), showWaitlistSettings = _e[0], setShowWaitlistSettings = _e[1];
    var session = useSession().data;
    var shop = getSessionShop(session);
    var _f = useState('current'), activeView = _f[0], setActiveView = _f[1];
    var _g = useWalkInListState(activeView, true), unifiedClients = _g.unifiedClients, isLoading = _g.isLoading, error = _g.error, selectedDate = _g.selectedDate, removeWalkInClient = _g.removeWalkInClient, notifyWalkInClient = _g.notifyWalkInClient, handleDateChange = _g.handleDateChange, isNotifyingClientById = _g.isNotifyingClientById; // Pass true to enable auto-refetching when modal is open
    var _h = useUpdateWalkInListSettings(), updateSettings = _h.updateSettings, isUpdatingSettings = _h.isLoading;
    var waitingListSettings = useWaitingListSettings().data;
    var handleOpenAddWalkInModal = function () {
        setShowAddWalkIn(true);
    };
    var handleCloseAddWalkIn = function () {
        setShowAddWalkIn(false);
    };
    var handleSettingsClick = function () {
        setShowWaitlistSettings(true);
    };
    var handleRemoveClient = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removeWalkInClient(clientId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error('Failed to remove client:', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAccept = function (client) {
        setSelectedClient(client);
    };
    var handleSaveSettings = function (settings) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!(shop === null || shop === void 0 ? void 0 : shop.id)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateSettings(shop.id, settings)];
                case 1:
                    _a.sent();
                    setShowWaitlistSettings(false);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error('Failed to update settings:', err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleNotify = function (client) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, notifyWalkInClient(client.id)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    console.error('Failed to notify client:', err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "walk-in-list-modal", children: [_jsx("div", { className: "walk-in-list-backdrop", onClick: onClose, role: "button", tabIndex: 0, "aria-label": t('appointment:walk_in_list.close_aria_label'), onKeyDown: function (e) {
                    if (e.key === 'Escape') {
                        onClose();
                    }
                } }), _jsxs("div", { className: "walk-in-list-panel", children: [_jsx(WalkInListHeader, { onClose: onClose, onSettingsClick: handleSettingsClick, onAddWalkIn: handleOpenAddWalkInModal }), _jsxs(Tabs, { active: tabIndex, children: [_jsx(Tabs.Tab, { title: t('appointment:walk_in_list.tabs.today'), onTabClick: function () { return function () {
                                    setTabIndex(TAB_INDEX_TODAY);
                                    setActiveView('current');
                                }; }, deny: false, allow: false, disabled: false, children: _jsx(WalkInListContent, { clients: unifiedClients, isLoading: isLoading, activeView: activeView, onRemoveClient: handleRemoveClient, isNotifyingClientById: isNotifyingClientById, onHandleAccept: handleAccept, onHandleNotify: handleNotify }) }), _jsxs(Tabs.Tab, { title: t('appointment:walk_in_list.tabs.full_list'), onTabClick: function () { return function () {
                                    setTabIndex(TAB_INDEX_FULL_LIST);
                                    setActiveView('history');
                                }; }, deny: false, allow: false, disabled: false, children: [_jsx(WalkInListDatePicker, { currentDate: selectedDate, onChange: handleDateChange }), _jsx(WalkInListContent, { clients: unifiedClients, isLoading: isLoading, activeView: activeView, onRemoveClient: handleRemoveClient, isNotifyingClientById: isNotifyingClientById, onHandleAccept: handleAccept, onHandleNotify: handleNotify })] })] }), error && (_jsx("div", { className: "walk-in-list-error", children: _jsx("p", { children: error }) })), showAddWalkIn && _jsx(AddWalkInClientContainer, { close: handleCloseAddWalkIn }), selectedClient && (_jsx(CustomAcceptWalkInClient, { walkInItem: selectedClient, onClose: function () { return setSelectedClient(null); } })), showWaitlistSettings && (_jsx(WaitlistSettings, { isOpen: showWaitlistSettings, onRequestClose: function () { return setShowWaitlistSettings(false); }, onSaveSettings: handleSaveSettings, isLoading: isUpdatingSettings }, "waitlist-settings-".concat(JSON.stringify(waitingListSettings))))] })] }));
};
